import type { RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { MenuItem } from "consts/openBanking";

export const selectIsOpenBankingResourceUninitialized = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.openBanking[menuItem].tableLoadingState === ApiState.Idle;

export const selectIsOpenBankingResourceSucceeded = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.openBanking[menuItem].tableLoadingState === ApiState.Succeeded;

export const selectIsOpenBankingResourceLoading = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.openBanking[menuItem].tableLoadingState === ApiState.Pending;

export const selectIsExportOpenBankingResourceLoading = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.openBanking[menuItem].exportLoadingState === ApiState.Pending;

export const selectOpenBankingResourceSlice = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.openBanking[menuItem].tableSlice;
